export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SET_LOADING = 'SET_LOADING'
export const SET_EXPORT_LOADING = 'SET_EXPORT_LOADING'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_HIGHLIGHTED = 'SET_HIGHLIGHTED'